import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from '@mui/material';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showMessage } from '../../actions/uiActions';
import AdministratorsApi from '../../api/administrators';
import moment from 'moment';

class DefaultForgivenessModal extends Component {
  state = {
    processing: false,
    loanName: '',
    amount: 0,
    repaymentDate: null,
    outOfDefaultId: null,
    isEdit: false,
  };
  componentDidMount() {
    const { loanOutOfDefault } = this.props;
    this.setState({
      isEdit: !!loanOutOfDefault,
      ...this.props.loanOutOfDefault,
      repaymentDate: loanOutOfDefault?.repaymentDate
        ? moment(loanOutOfDefault.repaymentDate, 'MM/DD/YYYY').format(
          'YYYY-MM-DD',
        )
        : null,
      outOfDefaultId: loanOutOfDefault?._id,
    });
  }

  validateFields = () => {
    const { loanName, amount, repaymentDate } = this.state;
    if (!loanName) {
      showMessage('Loan name is required');
      return;
    }
    if (!amount) {
      showMessage('Default amount is required');
      return;
    }
    if (!repaymentDate) {
      showMessage('Default date is required');
      return;
    }
    return true;
  };

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({
      processing: false,
      loanName: '',
      amount: 0,
      repaymentDate: null,
      outOfDefaultId: null,
      isEdit: false,
    });
    onClose();
  };
  handleSubmit = async () => {
    const { showMessage, onClose, onSuccess, userId } = this.props;
    const {
      loanName,
      amount,
      repaymentDate,
      isEdit,
      outOfDefaultId,
    } = this.state;

    try {
      if (this.validateFields()) {
        const payload = {
          loanName,
          amount,
          repaymentDate,
          userId,
        };
        this.setState({ processing: true });
        if (isEdit) {
          await AdministratorsApi.editLoanOutOfDefault(payload, outOfDefaultId);
          showMessage('Default loan successfully edited');
        } else {
          await AdministratorsApi.createLoanOutOfDefault(payload);
          showMessage('Default loan successfully added');
        }

        this.setState({ processing: false });
        onSuccess();
        onClose();
      }
    } catch (error) {
      this.setState({ processing: false });
      showMessage(error.message);
    }
  };

  handleChanges = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  render() {
    const { onClose } = this.props;
    const {
      loanName,
      processing,
      amount,
      repaymentDate,
      loanOutOfDefault,
    } = this.state;

    return (
      <Dialog
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        open={true}
        onClose={onClose}
        fullWidth
      >
        <DialogTitle id='alert-dialog-title'>
          Record loan out of default for this borrower
        </DialogTitle>
        <DialogContent>
          <div className='form-group nice'>
            <label>Loan Type and/or Loan Servicer:</label>
            <input
              disabled={processing}
              type='text'
              className='form-control'
              placeholder='Loan Type and/or Loan Servicer'
              name='loanName'
              value={loanName}
              onChange={this.handleChanges}
            />
          </div>

          <div className='form-group nice'>
            <label>Amount:</label>
            <input
              disabled={processing}
              type='number'
              className='form-control'
              placeholder='Default Amount'
              name='amount'
              value={amount}
              onChange={this.handleChanges}
            />
          </div>
          <div className='form-group nice'>
            <label>Default Date:</label>
            <input
              disabled={processing}
              type='date'
              className='form-control'
              placeholder='Default Date'
              name='repaymentDate'
              value={repaymentDate}
              onChange={this.handleChanges}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>
          {processing && <LinearProgress />}
        </DialogContent>
        {!processing && (
          <DialogActions>
            <Button
              variant='outlined'
              onClick={this.handleSubmit}
              color='primary'
              autoFocus
            >
              Submit
            </Button>
            <Button onClick={onClose} color='primary'>
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}
export default connect(null, { showMessage })(DefaultForgivenessModal);
